<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-09-03 17:26:02
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2024-09-04 17:20:25
 * @FilePath: \front\src\views\Patient\components\user-bio.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="bio-quota">
		<div class="bio-tab">
			<div class="tab" :class="{active: currentTab == 1}" @click="handleBioTab(1)">血压</div>
			<div class="tab" :class="{active: currentTab == 2}" @click="handleBioTab(2)">血糖</div>
			<div class="tab" :class="{active: currentTab == 3}" @click="handleBioTab(3)">血脂</div>
			<div class="tab" :class="{active: currentTab == 8}" @click="handleBioTab(8)">糖化血红蛋白</div>
			<div class="tab" :class="{active: currentTab == 4}" @click="handleBioTab(4)">血尿酸</div>
			<div class="tab" :class="{active: currentTab == 5}" @click="handleBioTab(5)">体重</div>
			<!--章丘 丙肝抗体6 丙肝病毒7 -->
			<div class="tab" v-if="hospitalCode==='SD_ZQ1'" :class="{active: currentTab == 6}" @click="handleBioTab(6)">丙肝抗体</div>
			<div class="tab" v-if="hospitalCode==='SD_ZQ1'" :class="{active: currentTab == 7}" @click="handleBioTab(7)">丙肝病毒</div>
			<!-- 三明第一 -->
			<template v-if="hospitalCode==='FJ_SM1'||hospitalCode==='YS_HM4'">
				<div class="tab"  :class="{active: currentTab == 9}" @click="handleBioTab(9)">乙肝DNA测定</div>
				<div class="tab"  :class="{active: currentTab == 10}" @click="handleBioTab(10)">丙肝RNA测定</div>
				<div class="tab"  :class="{active: currentTab == 11}" @click="handleBioTab(11)">谷丙转氨酶</div>
				<div class="tab"  :class="{active: currentTab == 12}" @click="handleBioTab(12)">谷草转氨酶</div>
				<div class="tab"  :class="{active: currentTab == 13}" @click="handleBioTab(13)">甲胎蛋白</div>
			</template>
			
		</div>
		
		<Bio1 v-if="currentTab === 1" :patientId="patientId" />
		<Bio2 v-if="currentTab === 2" :patientId="patientId" />
		<Bio3 v-if="currentTab === 3" :patientId="patientId" />
		<Bio4 v-if="currentTab === 4" :patientId="patientId" />
		<Bio5 v-if="currentTab === 5" :patientId="patientId" />
		<Bio8 v-if="currentTab === 8" :patientId="patientId" />
		<Bio6 v-if="currentTab === 6||currentTab === 7" :patientId="patientId" :currentTab="currentTab"/>
		<Bio9 v-if="currentTab >=9&&currentTab <=13" :currentTab="currentTab" :patientId="patientId" />

		<!-- <Bio7 v-if="currentTab === 7" :patientId="patientId" /> -->
	</div>	
</template>

<script>
import mixin from '@/views/mixin';
// import {Chart} from 'highcharts-vue';
import api from '@/service/api.js';
import dayjs from 'dayjs';

import Bio1 from './user-bio-1.vue';
import Bio2 from './user-bio-2.vue';
import Bio3 from './user-bio-3.vue';
import Bio4 from './user-bio-4.vue';
import Bio5 from './user-bio-5.vue';
import Bio8 from './user-bio-8.vue';
import Bio6 from './user-bio-6.vue';
import Bio9 from './user-bio-9.vue';

export default {
	components: { Bio1, Bio2, Bio3, Bio4, Bio5,Bio8,Bio6,Bio9},
  mixins: [mixin],
	data(){
		return {
			hospitalCode:'YS_HM4',
			noSidebar: true,
			currentTab: 1,
			patientId: 0,
		}
	},
	created() {
		let query = this.$route.query;
		// this.isRelativeFormActive = true;
		this.currentTab = +query.s || 1;
		this.patientId = +query.patientId;
		this.init();
	},
	methods: {
		async init(){
			this.hospitalCode=await api.getHospitalCode()
		},
		handleBioTab(v) {
			let query = this.$route.query;
			this.currentTab = v;
			this.$router.push({name: 'Patient/User', query: {patientId: +query.patientId, t: +query.t, s: v}});
		},
	}
}	
</script>

<style lang="less" scoped>
@import './user-bio.less';
</style>
